import styled from 'styled-components';

interface AnchorProps {
	styles?: React.CSSProperties;
}

export const Anchor = styled.a<AnchorProps>`
	display: ${props => props.styles?.display};
	transition: ${props => props.styles?.transition};
	font-size: ${props => props.styles?.fontSize};
	font-weight: ${props => props.styles?.fontWeight};
	color: ${props => props.styles?.color};
	top: ${props => props.styles?.top};
	left: ${props => props.styles?.left};
	right: ${props => props.styles?.right};
	bottom: ${props => props.styles?.bottom};
	overflow: ${props => props.styles?.overflow};
	border: ${props => props.styles?.border};
	position: ${props => props.styles?.position};
	opacity: ${props => props.styles?.opacity};
	width: ${props => props.styles?.width};
	height: ${props => props.styles?.height};
	margin: ${props => props.styles?.margin};
	margin-top: ${props => props.styles?.marginTop};
	margin-right: ${props => props.styles?.marginRight};
	margin-bottom: ${props => props.styles?.marginBottom};
	margin-left: ${props => props.styles?.marginLeft};
	padding: ${props => props.styles?.padding};
	padding-top: ${props => props.styles?.paddingTop};
	padding-right: ${props => props.styles?.paddingRight};
	padding-bottom: ${props => props.styles?.paddingBottom};
	padding-left: ${props => props.styles?.paddingLeft};
	background-color: ${props => props.styles?.backgroundColor};
	z-index: ${props => props.styles?.zIndex};
	background-image: ${props => props.styles?.backgroundImage};
	text-align: ${props => props.styles?.textAlign};
`;
